import React from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap'
import { useEffect } from "react";

function ReactWeb() {

    const Porfolio = [
        { P: 'Iphone 3D', L: '/iphone-3d', C: 'image iphone' },
        { P: 'Editable 3d card', L: '/editable-3d-card', C: 'image card-3d' },
        { P: 'Pokedex', L: '/pokedex', C: 'image pokedex' },
        { P: 'Rick and Morty Versus', L: '/rick-and-morty-versus', C: 'image rym' },
        { P: 'Learn Yugioh', L: '/learn-yugioh', C: 'image yugioh' },
        { P: 'Anime Sticker', L: '/anime-sticker', C: 'image anime' },
        { P: 'Tu Salud', L: '/tu-salud', C: 'image tusalud' },
        { P: 'Calm Yoga', L: '/calm-yoga', C: 'image yoga' },
        { P: 'Merry Christmas', L: '/merry-christmas', C: 'image merry' },
    ];

    useEffect(() => {
        gsap.from('.card',
            {
                duration: 0.1,
                scale: 0,
                stagger: 0.1,
                opacity: 0
            })
    }, []);

    return (
        <React.Fragment>
            <section className="Proyects">

                <h2 className="">React</h2>

                <div className='listPorfolio'>
                    {Porfolio.map(pro => (
                        <Link key={pro.P} to={pro.L} >

                            <div className='card'>
                                <div className='card-image'> <div className={pro.C}></div> </div>
                                <p className='card-title'> {pro.P} </p>
                            </div>
                        </Link>


                    ))}
                </div>

                <div className='after'>
                    <Link to="/porfolio" className="Link">  <div className='iconAfter'>  <p className='flechaProyect'>←</p></div>  </Link>
                </div>

            </section>
        </React.Fragment>
    );
}
export default ReactWeb;